// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){



    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function(){
            $(this).addClass("hover");
            $('ul.submenu',this).fadeIn(200);
        }, function(){
            $(this).removeClass("hover");
            $('ul.submenu',this).fadeOut(200);
        });

    });

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));



	//email signup animation
	const allInputsSignUp = document.querySelectorAll(".email-signup .input input")
	if (allInputsSignUp) {
	allInputsSignUp.forEach(input => {
		input.addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	});
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field');

		for (let j = 0; j < allffields.length; j++) {

			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
		}
	}


	// MENU Mobile
	let buttonMobile = document.getElementById('burgerMenu');
	if(buttonMobile != null){
	buttonMobile.addEventListener('click', function () {
			if (!this.classList.contains('open')) {
				this.parentElement.classList.add('open');
				this.classList.add('open');
				document.querySelector(".overlay").classList.add("open");
				document.getElementById("secondary-menu-header").classList.remove("hidden");
				document.getElementById("logoMobile").classList.remove("hidden");
			}
			 else {
				this.classList.remove('open');
				let button = document.getElementById("Close").parentElement.parentElement;
				button.removeChild();
				this.parentElement.classList.remove('open');
				document.querySelector(".overlay").classList.remove("open");
			}
		});
		//close btn mobile
		let closeBtn = document.querySelectorAll(".close-menu")[0];
		if(closeBtn){
			closeBtn.addEventListener('click', function(){
				document.getElementById("secondary-menu-header").classList.add("hidden");
				document.getElementById("logoMobile").classList.add("hidden");
				document.querySelectorAll('.overlay')[0].classList.remove('open');
				document.getElementById('burgerMenu').classList.remove('open');
			})
		}
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}